export const GNBZIndex = 100;
export const NewNoticeZIndex = 1100; // MuiDrawer-paper z-index 가 1200임

export const LeftDrawerLayoutZIndex = 99;
export const MainSNBZIndex = 99;
export const CollapsibleSideMenuZIndex = 99;
export const TopToScrollButtonZIndex = 100;
export const ProfileCardPopperZIndex = 1301; // Modal z-index 가 1300임
export const PassportMultiSelectZIndex = 1301; // Modal 1300 · MuiDrawer-paper 1200 둘 다 위
export const HighZIndex = 4000; // 최상위 z-index
export const NotificationZIndex = HighZIndex - 1;
